import api from './api';

export default {
    getRoles(){
        return api.get(`${process.env.VUE_APP_URL}/roles`);
    },
    getMarkets(){
        return api.get(`${process.env.VUE_APP_URL}/markets`);
    },
}